import { Fragment } from "react"
import { MentionText } from "@/features/project/who-link"
import { RefChip } from "./ref-chip"
import { splitRefs } from "./refs"

/**
 * Plain text with its refs as chips (wave K §10.1): for text that is not rendered as markdown (the Overview's brief
 * lines, a decided card's line). A ref the surface's resolver doesn't know stays text. In the main chunk. @mentions of
 * the project's agents and people open their page (`MentionText`, UX pass 2026-10-15).
 */
export function RefText({
  text,
  plain = false,
}: {
  text: string
  /** Chips that are never buttons: for text inside a link or a button (no nested interactive content). */
  plain?: boolean | undefined
}) {
  const pieces = splitRefs(text)
  if (pieces.length === 1 && typeof pieces[0] === "string") return <MentionText text={text} plain={plain} />
  return (
    <>
      {pieces.map((p, i) =>
        typeof p === "string" ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: pieces of one string, in order
          <Fragment key={i}>
            <MentionText text={p} plain={plain} />
          </Fragment>
        ) : (
          // biome-ignore lint/suspicious/noArrayIndexKey: the same ref may appear twice
          <RefChip key={i} refText={p.ref} plain={plain} />
        ),
      )}
    </>
  )
}
